import useEllipsisMenu from "../components/EllipsisMenu/useEllipsisMenu"
import { WorkflowScans } from "../types/types"
import { saveAs } from 'file-saver'
import { getDate, showErrorToast, showLoadingToast } from "../utils/utils";
import useFetchAllWorkflowData from "./useFetchAllWorkflowData";
import { useEffect, useState } from "react";
import { Id, toast } from "react-toastify";

const useExportWorkflowData = () => {

  const [{
    workflowScans,
    isLoading,
    error,
    fetchWorkflowData
  }] = useFetchAllWorkflowData()

  const [shouldExportWorkflow, setShouldExportWorkflow] = useState<boolean>(false)
  const [loadingToastId, setLoadingToastId] = useState<Id|undefined>(undefined)

  useEffect(() => {
    /**
     * Export workflow to file preserving entities and relationships.
     */
    const exportWorkflow = () => {
      if (workflowScans === undefined) { return }
      const workflow = workflowScans.workflow
      const workflowString = JSON.stringify(workflow)
  
      const sectionScansString = JSON.stringify(workflowScans.sections.map(((section) => section.sectionScan)))
      const isolatedScansString = JSON.stringify(workflowScans.sections.map((section) => section.scans).flat())    
      const isolatedScanImuString = JSON.stringify(workflowScans.sections.map((section) => section.imu).flat())
      const isolatedScanMotionString = JSON.stringify(workflowScans.sections.map((section) => section.motion).flat())
      const isolatedScanThermalString = JSON.stringify(workflowScans.sections.map((section) => section.thermal).flat())
      const scanMediaString = JSON.stringify(workflowScans.sections.map((section) => section.media).flat())
      const systemDataString = JSON.stringify(workflowScans.sections.map((section) => section.systemData).flat())
      // const data = workflowString + "\n" + sectionScansString + "\n" + isolatedScansString + "\n" + isolatedScanImuString + "\n" + scanMediaString + "\n"
      const csvContent = 
        workflowString + 
        "\n" + 
        sectionScansString + 
        "\n" + 
        isolatedScansString + 
        "\n" + 
        isolatedScanImuString + 
        "\n" + 
        isolatedScanMotionString +
        "\n" +
        isolatedScanThermalString +
        "\n" +
        scanMediaString +
        "\n" +
        systemDataString

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      saveAs(blob, `${workflowScans.workflow.pipe_id}.csv`)
    }

    if (shouldExportWorkflow) {
      exportWorkflow()
    }

    if (shouldExportWorkflow && loadingToastId !== undefined) {
      toast.done(loadingToastId)
    }
  }, [workflowScans, shouldExportWorkflow, loadingToastId])

  useEffect(() => {
    if (error !== null) {
      showErrorToast("Failed to export workflows.")
    }
  }, [error])

  const { ellipsisMenu: ellipsisMenuWorkflow } = useEllipsisMenu({
    items: [
      {
        item: "Export workflow",
        onClick: () => attemptToDownloadData()
      }
    ]
  })

  const { ellipsisMenu: ellipsisMenuThz } = useEllipsisMenu({
    items: [
      {
        item: "Export scans",
        onClick: () => alert("Exporting THz data is disabled temporarily.")
        // onClick: () => exportTHzData()
      }
    ]
  })

  const { ellipsisMenu: ellipsisMenuMetal } = useEllipsisMenu({
    items: [
      {
        item: "Export metal",
        onClick: () => alert("Exporting metal data is disabled temporarily.")
        // onClick: () => exportMetalData()
      }
    ]
  })

  const { ellipsisMenu: ellipsisMenuThermal } = useEllipsisMenu({
    items: [
      {
        item: "Export thermal",
        onClick: () => alert("Exporting thermal data is disabled temporarily.")
        // onClick: () => exportThermalData()
      }
    ]
  })

  const { ellipsisMenu: ellipsisMenuMotion } = useEllipsisMenu({
    items: [
      {
        item: "Export motion",
        onClick: () => alert("Exporting motion data is disabled temporarily.")
        // onClick: () => exportScanMotionData()
      }
    ]
  })

  const { ellipsisMenu: ellipsisMenuAngles } = useEllipsisMenu({
    items: [
      {
        item: "Export angles",
        onClick: () => alert("Exporting angle data is disabled temporarily.")
        // onClick: () => exportScanAngleData()
      }
    ]
  })

  const { ellipsisMenu: ellipsisMenuMedia } = useEllipsisMenu({
    items: [
      {
        item: "Export images",
        onClick: () => exportScanImages()
      }
    ]
  })

  /**
     * Converts array of sensor values to csv format.
     * 
     * @param data to be encoded
     * 
     * @returns csv data
     */
    // const arrayToCSV = (data: number[][]): string => {
    //   return data.map(row => row.join(",")).join("\n")
    // }
  
    
    /**
     * Exports workflows isolated scans into a single csv file.
     */
    // const exportTHzData = async () => {
    //   if (workflowScans === undefined) { return }
      
    //   for (let section=0; section<workflowScans.sections.length; section++) {
    //     const data: number[][] = []
        
    //     for (let i=0; i<workflowScans.sections[section].scans.length; i++) {
    //       const isolatedScan = workflowScans.sections[section].scans[i]
    //       data.push(isolatedScan.sensor_1)
    //       data.push(isolatedScan.sensor_2)
    //       data.push(isolatedScan.sensor_3)
    //       data.push(isolatedScan.sensor_4)
    //     }
    //     const csvContent = arrayToCSV(data)
    //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    //     saveAs(blob, `${workflowScans.workflow.pipe_id}_section:${section+1}_thz.csv`)
    //   }
    // }

    // const exportMetalData = async () => {
    //   if (workflowScans === undefined) { return }
      
    //   for (let section=0; section<workflowScans.sections.length; section++) {
    //     const data: number[][] = []
        
    //     for (let i=0; i<workflowScans.sections[section].imu.length; i++) {
    //       const isolatedScanImu = workflowScans.sections[section].imu[i]
    //       data.push(isolatedScanImu.metal)
    //     }
    //     const csvContent = arrayToCSV(data)
    //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    //     saveAs(blob, `${workflowScans.workflow.pipe_id}_section:${section+1}_metal.csv`)
    //   }
    // }

    // const exportThermalData = async () => {
    //   if (workflowScans === undefined) { return }
      
    //   for (let section=0; section<workflowScans.sections.length; section++) {
    //     const data: number[][] = []
        
    //     for (let i=0; i<workflowScans.sections[section].thermal.length; i++) {
    //       const thermal = workflowScans.sections[section].thermal[i]
    //       data.push(thermal.sensor_1)
    //       data.push(thermal.sensor_2)
    //     }
    //     const csvContent = arrayToCSV(data)
    //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    //     saveAs(blob, `${workflowScans.workflow.pipe_id}_section:${section+1}_thermal.csv`)
    //   }
    // }

    // const exportScanAngleData = async () => {
    //   if (workflowScans === undefined) { return }
      
    //   for (let section=0; section<workflowScans.sections.length; section++) {
    //     const data: number[][] = []
        
    //     for (let i=0; i<workflowScans.sections[section].imu.length; i++) {
    //       const angle = workflowScans.sections[section].imu[i]
    //       data.push(angle.roll_angles)
    //       data.push(angle.pitch_angles)
    //       data.push(angle.inclination_angles)
    //     }
    //     const csvContent = arrayToCSV(data)
    //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    //     saveAs(blob, `${workflowScans.workflow.pipe_id}_section:${section+1}_roll_pitch_inclination.csv`)
    //   }
    // }

    // const exportScanMotionData = async () => {
    //   if (workflowScans === undefined) { return }
      
    //   for (let section=0; section<workflowScans.sections.length; section++) {
    //     const data: number[][] = []
        
    //     for (let i=0; i<workflowScans.sections[section].motion.length; i++) {
    //       const motion = workflowScans.sections[section].motion[i]
    //       data.push(motion.delta_x)
    //       data.push(motion.delta_y)
    //     }
    //     const csvContent = arrayToCSV(data)
    //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    //     saveAs(blob, `${workflowScans.workflow.pipe_id}_section:${section+1}_motion.csv`)
    //   }
    // }

    const attemptToDownloadData = async () => {
      if (workflowScans !== undefined && !isLoading) {
        setShouldExportWorkflow(true)
        return
      }
      setLoadingToastId(showLoadingToast("Downloadig all workflow data."))
      setShouldExportWorkflow(false)
      await fetchWorkflowData()
      setShouldExportWorkflow(true)
    }

    const exportScanImages = () => {
      alert("Exporting images is temporarily disabled.")
      // if (workflowScans === undefined) { return }
      // for (let section=0; section<workflowScans.sections.length; section++) {
        
      //   for (let i=0; i<workflowScans.sections[section].media.length; i++) {
      //     const media = workflowScans.sections[section].media[i]
          
      //     const a = document.createElement('a');
      //           a.href = `data:image/png;base64,${media.base64_string}`
      //           a.download = `${getDate(media.date)}`
                
      //           document.body.appendChild(a)
      //           a.click()
      //           document.body.removeChild(a)
      //   }
      // }
    }
  

  return [{
    ellipsisMenuWorkflow,
    ellipsisMenuThz,
    ellipsisMenuMetal,
    ellipsisMenuMotion,
    ellipsisMenuThermal,
    ellipsisMenuAngles,
    ellipsisMenuMedia
  }]
}

export default useExportWorkflowData